// ======================================================================
// File Name       : userHistoryStudent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_HISTORY_STUDENT_GET_GROUP_LIST = 'USER_HISTORY_STUDENT_GET_GROUP_LIST';
export const USER_HISTORY_STUDENT_OPEN_GROUP_DIALOG = 'USER_HISTORY_STUDENT_OPEN_GROUP_DIALOG';
export const USER_STUDENT_GET_GROUP_RELATION_LIST = 'USER_STUDENT_GET_GROUP_RELATION_LIST';
export const USER_STUDENT_GET_USER_LIST = 'USER_STUDENT_GET_USER_LIST';
export const USER_STUDENT_GET_COURSE_STATUS_LIST = 'USER_STUDENT_GET_COURSE_STATUS_LIST';
export const USER_STUDENT_GET_COURSE_INFO_LIST = 'USER_STUDENT_GET_COURSE_INFO_LIST';
export const USER_STUDENT_GET_HISTORY_LIST = 'USER_STUDENT_GET_HISTORY_LIST';
export const USER_STUDENT_GET_COURSE_LIST = 'USER_STUDENT_GET_COURSE_LIST';
export const USER_STUDENT_GET_CONTENT_LIST = 'USER_STUDENT_GET_CONTENT_LIST';
export const USER_STUDENT_GET_ITEM_LIST = 'USER_STUDENT_GET_ITEM_LIST';
export const RECEIVE_QUESTION_USE_RECORD_BY_STD = 'RECEIVE_QUESTION_USE_RECORD_BY_STD';
export const RECEIVE_DRILL_ENFORCE_HISTORY_BY_STD = 'RECEIVE_DRILL_ENFORCE_HISTORY_BY_STD';
export const RECEIVE_QUESTION_HTML_DETAIL = 'RECEIVE_QUESTION_HTML_DETAIL';
export const SAVE_HISTORY_COURSE_DETAIL = 'SAVE_HISTORY_COURSE_DETAIL';
export const RESET_HISTORY_COURSE_DETAIL = 'RESET_HISTORY_COURSE_DETAIL';
export const RECEIVE_USER_HISTORY_DETAIL_INIT = 'RECEIVE_USER_HISTORY_DETAIL_INIT';
export const GET_EACH_USER_COURSE_STATUS_COUNT = 'GET_EACH_USER_COURSE_STATUS_COUNT';
export const RESET_LEARNING_HISTORY_LIST = 'RESET_LEARNING_HISTORY_LIST';
export const RESET_COURSE_STATUS_LIST = 'RESET_COURSE_STATUS_LIST';

